import React from 'react'
import { useTranslation } from 'react-i18next';

export default function Settings() {

    const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş
    return (
        <>
            <div className="section title-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title d-flex justify-content-start align-items-center">
                                <div className="title-icon"><i className="bi bi-sliders"></i></div>
                                <div className="title-content">
                                    <h1>{t('settings')}</h1>
                                    <p>{t('manageSettings')}</p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <div className="section section-analytics my-4">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card-block card-block-02">
                                <h2 className="card-title">{t('analyticsSettings')}</h2>
                                <div className="card-content">
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <label htmlFor="g4Tag" className="form-label">{t('g4tag')}</label>
                                            <textarea className="form-control" id="g4Tag" rows={4}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section section-analytics my-4">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card-block card-block-02">
                                <h2 className="card-title">{t('contactSetting')}</h2>
                                <div className="card-content">
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <label htmlFor="phone" className="form-label">{t('Phone')}</label>
                                            <input type='text' className="form-control" id="phone"></input>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label htmlFor="whatsapp" className="form-label">{t('whatsappSupport')}</label>
                                            <input type='text' className="form-control" id="whatsapp"></input>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label htmlFor="address" className="form-label">{t('address')}</label>
                                            <input type='text' className="form-control" id="address"></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
